import React from 'react';
import ServiceCard from './ServiceCard';

/**
 * Grid component for displaying service cards
 * @param {Object} props - Component props
 * @param {Array} props.services - Array of service objects
 * @returns {React.ReactElement} ServicesGrid component
 */
const ServicesGrid = ({ services }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 md:gap-10 lg:gap-16 my-6 md:my-10 lg:my-12">
      {services.map((service) => (
        <ServiceCard
          key={service.title}
          icon={service.icon}
          title={service.title}
          blurb={service.blurb}
          href={service.href}
          id={service.id || service.title.toLowerCase().replace(/\s+/g, '-')}
        />
      ))}
    </div>
  );
};

export default ServicesGrid;
